"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.List = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactWindowSize = _interopRequireDefault(require("react-window-size"));
var _List = require("./List.style");
var _Item = _interopRequireDefault(require("../../../../../../Announcements/Item"));
const List = _ref => {
  let {
    items
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_List.Container, null, items.map(x => /*#__PURE__*/_react.default.createElement(_List.Wrapper, {
    key: x.id
  }, /*#__PURE__*/_react.default.createElement(_Item.default, x))));
};
exports.List = List;
var _default = exports.default = (0, _reactWindowSize.default)(List);